import React from "react"
import Clickable from "@components/clickable"
import Button from "@components/button"
import config from "@config"
import classnames from "@utils/classnames"
import { platformCheck, postAppMsg } from "@utils/request"
import styles from "./fixedBottomButtons.module.scss"
import { Share } from "@components/icon"

const { url: linkUrl } = config

const FixedBottomButtons = ({ active }) => {
  return (
    <div className={classnames(styles.container, { [styles.active]: active })}>
      {process.env.NODE_ENV === "development" && (
        <button
          className={styles.devTheme}
          onClick={() => {
            const nextTheme =
              window.GCORES_APP_THEME === "dark" ? "light" : "dark"
            window.switchTheme(nextTheme)
            window.GCORES_APP_THEME = nextTheme
          }}
        >
          theme
        </button>
      )}
      <div className={styles.inner}>
        <Clickable
          className={styles.share}
          onClick={() => {
            platformCheck(
              () => {
                postAppMsg("share", {
                  image: linkUrl.poster,
                })
              },
              () => {},
              { needAdvanced: false, onlyInApp: true }
            )
          }}
        >
          <Share className={styles.shareIcon} />
          分享活动
        </Clickable>
        {/* <Clickable className={styles.left} appNavTo={linkUrl.volunteerEnroll}>
          志愿者招募
        </Clickable> */}
        <Clickable className={styles.center} appNavTo={linkUrl.creatorEnroll}>
          报名BOOOM
        </Clickable>
        <Button className={styles.right} appNavTo={linkUrl.ticket}>
          <span>线下延期通知</span>
          {/* <span>购买门票</span> */}
        </Button>
      </div>
    </div>
  )
}

export default FixedBottomButtons
